// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2vZDr","footer":"ModalUpdate_footer__2j2eW"};